import PropTypes from "prop-types";
import React from "react";
import { graphql } from "gatsby";

import Hero from "../components/hero/hero";
import Layout from "../components/layout/layout";
import PostSlider from "../components/post/slider";
import Section from "../components/section/section";
import Seo from "../components/seo/seo";
import SignUp from '../components/sign-up/sign-up';
import PostSingle from "./post-single";
import Sidebar from "../components/post/sidebar";

const BlogSingle = ({ data, location }) => {

  const post = data.wpPost;
  const posts = data.allWpPost;
  
  return (
    <Layout featured_media={ post.featuredImage } location={ location }>
      <Hero
        backgroundImg={ PostSingle.getBackgroundImageURL(post.featuredImage) }
        backgroundImgAlt={ "Hero image" }
        content={ post.title }
        department={ post.primaryService ?? post.servicesTaxonomy.nodes[0].slug }
        departmentText={ `Written by ${ post.author.node.firstName }`}
        type={ "post" }
        headingIsH1={true}
      />
      <section className="post-layout">
        <div className="post-wrapper">
          <div className="post-wrapper-top">
              <Sidebar 
                post={ post } 
                type={ "blog" } 
                department={ post.primaryService ?? post.servicesTaxonomy.nodes[0].slug }
              />
              <div className="post-wrapper-top-content">
                <Section
                  heading = { post.template.blog_post_h2_fields.blogPostH2 }
                  className="blog-wrapper"
                  content={ post.content } 
                  headingTag="div"
                  headingClasses="blog-intro"
                />
              </div>
          </div>
          <div className="post-wrapper-bottom" id="similar_posts_section">
              <div className="bkgd">
                <h2 className="h-large h-faded">more like this.</h2>
              </div>
              <PostSlider 
                overflow={ false } 
                posts={ posts } 
                useClientName={ false } 
                type="blog" 
              />
          </div>
        </div>
      </section>
      <SignUp />
    </Layout>
  );
}

export default BlogSingle;

BlogSingle.propTypes = {
    data: PropTypes.object.isRequired,
    edges: PropTypes.array,
}

export const Head = ({ location, params, data, pageContext }) => {
  const { wpPost } = data;
  const { seo } = wpPost;
  
  return <Seo seo={seo} pageContext={pageContext} />
};

export const pageQuery = graphql`
  query ($id: String!) {
    allWpPost(limit: 4, filter: {status: {eq: "publish"}, id: {ne: $id}}) {
        edges {
          node {
            id
            slug
            link
            date
            excerpt
            title
            primaryService
            primaryServiceTitle
            servicesTaxonomy {
              nodes {
                databaseId
                id
                name
                slug
              }
            }
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
        }
      }
      wpPost(id: {eq: $id}) {
        seo {
          fullHead
          title
        }
        author {
          node {
            firstName
            url
            slug
            avatar {
              url
            }
          }
        }
        id
        content
        date
        primaryService
        primaryServiceTitle
        link
        title
        servicesTaxonomy {
          nodes {
            databaseId
            id
            name
            slug
          }
        }
        template {
            ... on WpTemplate_Blog { 
              blog_post_h2_fields {
                blogPostH2
              }
            }
        }
        featuredImage {
          node {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
              }
            }
          }
        }
    }
  }
`